<template>
  <div class="dflexr-jcsa stat-pill">
    <div class="lbl-stat">
      {{stat}}
    </div>
    <div class="stat-val">
      {{valu}}
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>

<script setup>

import {computed} from "vue";

const props = defineProps(['key', 'val', 'name'])
const stat = computed(() => {
  let x = props.name
  if(props.name === 'ATTACKS') {
    x = '#AT'
  } else if (props.name === 'SPECIAL') {
    x = 'SP'
  } else if (props.name === 'JEWELS') {
    x = 'JW'
  }

  return x
})

const valu = computed(() => {

  let x =  props.val
  const sp = (props.name === 'SPECIAL' )
  const jw = (props.name === 'JEWELS' )

  if(x === null)
    x = '--'

  if(sp && x) {
    console.log('Special value check', props.val)
    x = 'Yes'
  }

  // if(jw && x) {
  //   console.log('Jewel value check, val:', props.val)
  //   x = 'Yes'
  // }

  return x
})

</script>
